module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentUser.stripe_connected) ? _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "flat": "",
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar-notification"
  }, [(_vm.content) ? _c('span', {
    staticClass: "top-bar__content"
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e(), _vm._v(" "), (_vm.cta) ? _c('v-btn', {
    staticClass: "top-bar__cta",
    attrs: {
      "to": _vm.cta,
      "outline": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.ctaTitle))]) : _vm._e()], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd1c5bf0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topbarNotification.vue
// module id = 1844
// module chunks = 180